import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { formatNumber } from "../../lib/number";
import Icon from "../Icon";
import style from "./style.module.scss";
const UpArrow = () => _jsx(Icon, { name: "arrow--up" });
const DownArrow = () => _jsx(Icon, { name: "arrow--down" });
export default function Change(props) {
    const { value, suffix = "", changeType, changeTooltip, largeMode, smallMode, noArrow = false } = props;
    let changeValue;
    let changeArrow = _jsx("span", {});
    if (value === Infinity) {
        changeValue = _jsx(Icon, { name: "infinity" });
        if (value < 0) {
            changeArrow = _jsx(UpArrow, {});
        }
        else {
            changeArrow = _jsx(DownArrow, {});
        }
    }
    else if (typeof value === "number") {
        changeValue = formatNumber(Math.abs(value));
        if (value < 0) {
            changeArrow = _jsx(UpArrow, {});
        }
        else {
            changeArrow = _jsx(DownArrow, {});
        }
    }
    else {
        changeValue = value;
    }
    if (noArrow) {
        changeArrow = _jsx("span", {});
    }
    //Apply type if it exists
    let typeClass;
    if (changeType) {
        typeClass = style[`change--${changeType}`];
    }
    //Apply large mode if it's turned on
    let largeClass;
    if (largeMode) {
        largeClass = style["change--large"];
    }
    //Apply large mode if it's turned on
    let smallClass;
    if (smallMode) {
        smallClass = style["change--small"];
    }
    //Add tool tip is data for it exists.
    let changeContext;
    if (changeTooltip) {
        changeContext = (_jsxs("div", { className: style["change__tooltip__container"], children: [_jsx("div", { className: style["change__tooltip__title"], children: changeTooltip.title }), _jsxs("div", { className: style["change__tooltip__row"], children: [_jsx("div", { children: changeTooltip.currentLabel }), _jsx("div", { children: formatNumber(changeTooltip.currentValue) })] }), _jsxs("div", { className: style["change__tooltip__row"], children: [_jsx("div", { children: changeTooltip.compareLabel }), _jsx("div", { children: formatNumber(changeTooltip.compareValue) })] }), _jsxs("div", { className: classNames(style["change__tooltip__row"], style["change__tooltip__change"]), children: [_jsx("div", { children: "Change" }), _jsxs("div", { className: style["change__tooltip__change-value"], children: [changeArrow, changeValue, suffix] })] })] }));
    }
    return (_jsxs("div", { className: classNames(style.change, typeClass, largeClass, smallClass), children: [_jsxs("div", { className: style["change__container"], children: [changeArrow, _jsxs("div", { className: style["change__value"], children: [changeValue, _jsx("span", { className: style["change__suffix"], children: suffix })] })] }), changeContext] }));
}
